import { StageType } from "@models/common"
import axios from "axios"
import { PageResponse } from "src/services/api/document"

export interface Assignment {
  assignmentId: string,
  jobName: string,
  dueDate: string,
  assignmentType: StageType
}

export async function getAssignments(offset = 0, limit = 6): Promise<PageResponse<Assignment>> {
  const params = {
    offset, limit,
    status: "ACCEPTED",
    stages: ["ENHANCEMENT", "TRUST_MINING", "CORRECTION"].join(",")
  }
  const resp = await axios.get("/api/wfl/portal/assignments", { params })
  const { totalCount, results } = resp.data
  return { totalCount, results }
}